import('./portableStartup')
  .then(({ gateReady }) => gateReady)
  .catch(error => {
    console.error('Host bootstrap failed', error)
  })
